import { Box } from '@mui/joy';
import { observer } from 'mobx-react-lite';

// @TODO: filter for traders
// filter for event types

export const TradeEventFilterTray = observer(() => (
  <h1>Trade event filter tray</h1>
));
